// extracted by mini-css-extract-plugin
module.exports = {"paginationContainer":"Pagination_paginationContainer__zXGsv"};